import { TStore } from '@/common/basis/types/tstore';

const state: TStore.Whole = {
  capability: undefined,
  isLanguageEn: false,
};

export default state;
